import { REPORTS_CLIENT } from "../clients/reports.client";
import { AxiosError } from "axios";

export interface LoginCredentials {
  provider?: "microsoft" | "google";
  email?: string;
  password?: string;
}

export interface LogoutResponse {
  message: string;
}

export interface AuthGuardResponse {
  status: "ok" | "error";
}

const redirectUrl = import.meta.env.VITE_REPORTS_API_URL;

export const redirectToAuthServer = async (credentials: LoginCredentials) => {
  if (credentials.provider) {
    window.location.href = `${redirectUrl}/auth/${credentials.provider}?redirect_url=${window.location.origin}`;
  }
};

export const postLogout = async (): Promise<LogoutResponse> => {
  try {
    const response = await REPORTS_CLIENT.post<LogoutResponse>("/logout", {});
    return response.data;
  } catch (error) {
    console.error("[postLogout] Logout failed", error);

    // Evitar loop infinito de logout
    if ((error as AxiosError)?.response?.status === 401) {
      console.log(
        "[postLogout] User already logged out (401), treating as success"
      );
      return { message: "User already logged out" };
    }
    throw error;
  }
};

export const checkUserSession = async (): Promise<boolean> => {
  try {
    // Setar no localStorage o timestamp exato ANTES de fazer a requisição
    const requestTimestamp = new Date().getTime();
    localStorage.setItem("last_auth_guard_request", requestTimestamp.toString());

    const response = await REPORTS_CLIENT.get<AuthGuardResponse>('/auth_guard');
    return response.data?.status === 'ok';
  } catch (error) {
    const status = (error as AxiosError)?.response?.status;

    // Só retorna false para unauthorized, outros erros não bloqueiam ações do usuário
    if (status === 401) {
      return false;
    }

    console.warn("[checkUserSession] Session check failed silently:", {
      status,
      message: (error as AxiosError)?.message
    });

    return true; // Considera como "válida" qualquer erro não 401
  }
};
